import { app } from '@df/core/app';
/**
 * Checks if given element is in viewport
 * @param  {Element} element to check
 * @param  {number}  tollerance  If > 1 then in pixesl, if < 1 then in % of element
 * @param  {string}  test  x - x axis only, y - y axis only, xy - both axis, top - top only, bottom - bottom only, x
 * -whole addition to check if whole elem is in viewport
 * @return {boolean}
 */
export function isInViewport(
    element: Element,
    tollerance: number = 500,
    test: 'x' | 'y' | 'xy' | 'top' | 'bottom' | 'xy-whole' | 'x-whole' | 'y-whole' = 'xy'
): boolean {
    const rect = element.getBoundingClientRect();

    if (tollerance <= 1 && tollerance > 0) {
        tollerance = -tollerance * rect.height;
    }
    const h = app.window.innerHeight || document.documentElement.clientHeight;
    const viewportTop = 0 - tollerance;
    const viewportBottom = h + tollerance;
    const w = app.window.innerWidth || document.documentElement.clientWidth;
    const viewportLeft = 0 - tollerance;
    const viewportRight = w + tollerance;

    switch (test) {
        case 'x':
        case 'y':
        case 'xy':
            if (test !== 'y') {
                // is whole on the left viewport
                if (rect.right < viewportLeft) {
                    return false;
                }
                // is whole on the right
                if (rect.left > viewportRight) {
                    return false;
                }
            }
            if (test !== 'x') {
                // is whole above
                if (rect.bottom < viewportTop) {
                    return false;
                }
                // is whole below
                if (rect.top > viewportBottom) {
                    return false;
                }
            }
            return true;
        case 'x-whole':
        case 'y-whole':
        case 'xy-whole':
            if (test !== 'y-whole') {
                // is any part left from viewport
                if (rect.left < viewportLeft) {
                    return false;
                }
                // is any part right from viewport
                if (rect.right > viewportRight) {
                    return false;
                }
            }
            if (test !== 'x-whole') {
                // is any part above
                if (rect.top < viewportTop) {
                    return false;
                }
                // is any part below
                if (rect.bottom > viewportBottom) {
                    return false;
                }
            }
            return true;
        case 'top':
            // is top in viewport
            return rect.top >= viewportTop && rect.top <= viewportBottom;
        case 'bottom':
            // is bottom in viewport
            return rect.bottom >= viewportTop && rect.bottom <= viewportBottom;
    }

    return true;
}
